<template>
    <div class="auth-wrap clear" ref="authWrapper">
        <div class="auth-content">
            <p>
                <font class="login-title">企业信息</font>
            </p>
            <el-form :model="registForm" :rules="rules" ref="registForm" label-width="70px" class="demo-ruleForm"
                     label-position="left">
                <el-form-item label="企业名称" prop="fullName" label-width="120px">
                    <el-input v-model="registForm.fullName"></el-input>
                </el-form-item>
                <el-form-item label="社会统一信用代码" prop="idCardNo" label-width="120px">
                    <el-input v-model="registForm.idCardNo"></el-input>
                </el-form-item>
                <el-form-item label="法定代表人" prop="corporation" label-width="120px">
                    <el-input v-model="registForm.corporation"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码" prop="corporationIdCardNo" label-width="120px">
                    <el-input v-model="registForm.corporationIdCardNo"></el-input>
                </el-form-item>
                <!-- <el-form-item label="联系人手机号" prop="mobile" label-width="120px">
                   <el-input v-model="registForm.mobile"></el-input>
                 </el-form-item> -->
                <el-form-item label="管理员姓名" prop="managerName" label-width="120px">
                    <el-input v-model="registForm.managerName"></el-input>
                </el-form-item>
                <el-form-item label="管理员账号" prop="managerPassport" label-width="120px">
                    <el-input v-model="registForm.managerPassport"></el-input>
                </el-form-item>
                <el-form-item label="管理员手机号" prop="managerMobile" label-width="120px">
                    <el-input v-model="registForm.managerMobile"></el-input>
                </el-form-item>
                <el-radio-group v-model="registForm.corpType" label-width="120px">
                    <el-radio label="group">集团</el-radio>
                    <el-radio label="corp">公司</el-radio>
                </el-radio-group>

                <div style="margin-bottom: 20px"></div>

                <el-form-item class="btn-item">
                    <el-button type="primary" @click="regist('registForm')">注册</el-button>
                    <ul>
                        <li class="not-accout">
                            <font>已有账号？</font>
                            <font @click="$router.push('/ssoLogin')">登入</font>
                        </li>
                    </ul>
                </el-form-item>
            </el-form>
        </div>

    </div>
</template>

<script>
    import rules from './config/rules';

    export default {
        data: function () {
            return {
                checked: true,
                registForm: {
                    fullName: '',
                    idCardNo: '',
                    corporation: '',
                    corporationIdCardNo: '',
                    mobile: '',
                    managerName: '',
                    managerPassport: '',
                    managerMobile: '',
                    corpType: 'group'
                },

                rules: rules
            };
        },
        mounted() {
            // this.appSize();
            // const that = this;
            //监听浏览器窗口大小改变
            // window.addEventListener(
            //   "resize",
            //   function() {
            //     that.appSize();
            //   },
            //   false
            // );
        },
        methods: {
            //注册
            regist(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // localStorage.setItem('ms_username',this.loginForm.name);
                        this.$api.post(this.$url.enterprise.save, this.registForm).then(resp => {
                            if (resp){
                                this.$api.success("注册成功,请等待管理员审核")
                                this.$router.push("/ssoLogin")
                            }
                        })

                    } else {
                        return false;
                    }
                });
            },
            appSize() {
                this.$refs.authWrapper.width = document.body.clientWidth;
                this.$refs.authWrapper.height = document.body.clientHeight;
            }
        }
    };
</script>

<style lang='less' scoped>
    @color03B7C7: #03B7C7;

    /*左侧文字*/
    .text {
        color: #fff;
        position: absolute;
        left: 3%;
        top: 45%;

        .title1 {
            width: 13%;
            text-align: right;
            font-size: 30px;
        }

        .title2 {
            text-align: left;
            font-size: 12px;
        }
    }

    .auth-wrap {
        margin: 0 auto;
        width: 28%;
        height: 100%;
        background: #fff;
        text-align: center;
        padding: 0 50px;
        display: table;

        .auth-content {
            display: table-cell;
            vertical-align: middle;

            p {
                margin-bottom: 35px;

                font {
                    font-size: 20px;
                    color: #4A4A4A;
                    font-weight: 600;
                    display: block;
                    height: 28px;
                    line-height: 28px;
                }

                span {
                    display: block;
                    font-size: 12px;
                    color: #d3d5d9;
                }
            }

            /deep/ .el-form {
                .el-form-item {
                    margin-bottom: 25px;
                }

                .el-checkbox {
                    float: left;
                }

                .checkbox-item {
                    margin-bottom: 10px;
                }

                .el-input--small {
                    .el-input__inner {
                        height: 40px;
                        line-height: 40px;
                        border-radius: 4px;
                    }
                }

                .btn-item {

                    .el-form-item__content {
                        width: 100%;
                        margin-left: 0 !important;
                    }

                    .el-button--primary {
                        width: 100%;
                        background-color: @color03B7C7;
                        border-color: @color03B7C7;
                        border-radius: 0;
                        padding: 15px 20px;
                        margin-bottom: 30px;
                    }

                    .not-accout {
                        height: 16px;
                        line-height: 16px;
                    }

                    .el-button--primary:focus,
                    .el-button--primary:hover {
                        background: #1e8e9e;
                        border-color: #1e8e9e;
                    }

                    font {
                        font-size: 12px;
                        color: #9b9b9b;
                    }

                    font:last-child {
                        color: @color03B7C7;
                        margin-left: 5px;
                        cursor: pointer;
                    }
                }
            }
        }
    }

    /* .login-wrap{
          position: relative;
          width:100%;
          height:100%;
          background-size: 100%;
      }
      .ms-title{
          width:100%;
          line-height: 50px;
          text-align: center;
          font-size:20px;
          color: #fff;
          border-bottom: 1px solid #ddd;
      }
      .ms-login{
          position: absolute;
          left:50%;
          top:50%;
          width:350px;
          margin:-190px 0 0 -175px;
          border-radius: 5px;
          background: rgba(255,255,255, 0.3);
          overflow: hidden;
      }
      .ms-content{
          padding: 30px 30px;
      }
      .login-btn{
          text-align: center;
      }
      .login-btn button{
          width:100%;
          height:36px;
          margin-bottom: 10px;
      }
      .login-tips{
          font-size:12px;
          line-height:30px;
          color:#fff;
      } */
</style>
